var render = function (_h,_vm) {var _c=_vm._c;return _c('v-card',{staticStyle:{"margin":"0 0 4px 4px"}},[_c('v-img',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.props.post.imageurl),expression:"props.post.imageurl",arg:"background-image"}],staticClass:"reviewCard",attrs:{"aspect-ratio":"0.9"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }